import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { inWhitelabel } from 'core/whitelabel';
import { FourOhFour } from 'apps/fourOhFour/index';

import Home from 'apps/home/main/index';
import { ActivityRouter } from 'apps/home/activityFeed/router';
// import { DiscoverRouter } from 'apps/home/discover/router';
import { FAQPage } from 'apps/home/faq/index';
import { PricingPage } from 'apps/home/pricing/index';
import { FileFormatsPage } from 'apps/home/fileFormats/index';
import { Upgrade } from 'apps/upgrade';

import { SignUp } from 'apps/profile/signUp/index';
import { SignUpOrganization } from 'apps/profile/signUp/organization';
// import { SignUpManufacturer } from 'apps/manufacturing/signup';
import { NewPasswordPage } from 'apps/signIn/newPassword/index';
// import {SignUp} from 'apps/profile/signUp/views/signup';
import LandingPage from 'apps/home/landing/index';
import { SignInPage } from 'apps/signIn/main/index';
import { GatewayPage } from 'apps/gateway';
import { NotificationsPage } from 'apps/notifications';
import { InvitePage } from 'apps/home/invite';
import { NewStory } from 'apps/story/newStory/index';
import NewProject from 'apps/project/newProject';
import { ImportProject } from 'apps/project/importProject/index';
import { SearchPage } from 'apps/search/index';
import { Contact } from 'apps/home/contact/index';
import { Privacy } from 'apps/home/privacy/index';
import { Terms } from 'apps/home/terms/index';
import { Cookies } from 'apps/home/cookies';
import { PostPage } from 'apps/aggregator/postPage/index';
import { FeaturesPage } from 'apps/home/features/index';
// micro site
import { MicroSite } from 'apps/microSite/index';
// import { ContributeMSRouter } from 'apps/microSite/pages/contribute/router';
// import { ConnectMSRouter } from 'apps/microSite/pages/connect/router';
// import { LearnRouter } from 'apps/microSite/pages/learn/router';

// new
// import { WorkspaceRouter } from 'apps/home/workspace/router';
import { CommunityRouter } from 'apps/home/community/router';
import { MarketplacePage } from 'apps/home/marketplace/index';
import { CompanyRouter } from 'apps/home/company/router';
import { DiscoverRouter } from 'apps/home/discover/router';
import { ConnectRouter } from 'apps/home/connect/router';

import { Redirect } from 'apps/home/redirect';

const viewsMap = {
  '': inWhitelabel() ? MicroSite : Home,
  // websites
  // workspace: WorkspaceRouter,
  community: CommunityRouter,
  marketplace: MarketplacePage,
  company: CompanyRouter,
  // platform
  home: LandingPage,
  connect: ConnectRouter,
  discover: DiscoverRouter,
  //
  features: FeaturesPage,
  faq: FAQPage,
  pricing: PricingPage,
  formats: FileFormatsPage,
  activity: ActivityRouter,
  notifications: NotificationsPage,
  gateway: GatewayPage,
  invite: InvitePage,
  signIn: SignInPage,
  signUpOrganisation: SignUpOrganization,
  // signUpManufacturer: SignUpManufacturer,
  signUp: SignUp,
  newPassword: NewPasswordPage,
  newStory: NewStory,
  newProject: NewProject,
  importProject: ImportProject,
  newInitiative: Upgrade,
  post: PostPage,
  search: SearchPage,
  contact: Contact,
  privacy: Privacy,
  terms: Terms,
  cookies: Cookies,
  redirect: Redirect,
  // micro site
  // contribute: ContributeMSRouter,
  // connect: ConnectMSRouter,
  // learn: LearnRouter,
};

@observer
class HomeSpace extends React.Component {
  render() {
    const View = this.props.componentFromRoute();
    return <View params={this.props.routerStore.params} />;
  }
}

HomeSpace.propTypes = {
  params: PropTypes.object,
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const HomeRouter = routeNode('home', viewsMap, FourOhFour)(HomeSpace);
